import { Component, ElementRef, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { DeviceBehfaService } from 'src/app/Service/DeviceBehfa/DeviceBehfa.service';
import { GeneralService } from 'src/app/Service/General/General.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';

import { NavService } from 'src/app/Service/Nav/Nav.service';

@Component({
  selector: 'app-DeviceBehfaDownloadForm',
  templateUrl: './DeviceBehfaDownloadForm.component.html',
  styleUrls: ['./DeviceBehfaDownloadForm.component.scss']
})
export class DeviceBehfaDownloadFormComponent implements OnInit {

  Token: String = ""

  Procssing: boolean = false;
  FormSubmitted: boolean = false;
  DowloadType: string = "1"
  LetterSchedules: String = "0"

  Fullname: String = ""
  nowDate: String = ""
  Check_Message:boolean=false

  constructor(
    private DeviceBehfa_Service: DeviceBehfaService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private General_Service: GeneralService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private modalService: BsModalService
  ) { }

  ngOnInit() {
    this.Token = localStorage.getItem('Daro_User_Token');
    this.Nav_Service.CheckValidPage(this.Token, 51).subscribe(
      data => {
        this.Fullname=localStorage.getItem('Daro_User_Fullname');
        this.General_Service.GetFullDate(this.Token+'').subscribe(
          data=>{
            this.ReadData_Mission()
            this.nowDate=data['fulldate']
          }
        )
      }
      , error => {
        localStorage.clear()
        location.reload();
      }
    )
  }


  ResetForm(){
    this.FormSubmitted=false
    this.Info_Download_List=[]
    this.Check_Message=false
    this.QRCodeInputDownload.nativeElement['value']=''
  }


  //#region Download
  Info_Download_List: Array<General_Interface> = []
  @ViewChild('QRCodeInputDownload') QRCodeInputDownload: ElementRef;

  QRCodeInputDownload_Enter() {
    this.Get_BehfaDevice_Info_Download(this.QRCodeInputDownload.nativeElement['value'])
  }

  Get_BehfaDevice_Info_Download(QRCodeInput: string) {

    if (!this.Procssing) {
      this.Procssing = true
      this.DeviceBehfa_Service.GetInfobyQR(this.Token, QRCodeInput).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDownload_Esc()

          if (data.id == -1) {
            this.Alertify_Service.ErrorMessage("The scanned QR code is invalid.")
          }
          else if (this.Info_Download_Exist(data)) {
            this.Alertify_Service.ErrorMessage("The scanned QR code already exists in the list.")
          }
          else {
            data.dsc=QRCodeInput
            this.Info_Download_List.push(data)
            this.Alertify_Service.SuccessMessage("Equipment information loaded successfully.")
          }

        }, error => {
          this.Procssing = false
          this.Alertify_Service.ErrorMessage("The scanned QR code is invalid.")

        }
      )
    }

  }

  QRCodeInputDownload_Esc() {
    this.QRCodeInputDownload.nativeElement['value'] = ''
  }

  Info_Download_Exist(input: General_Interface) {
    for (let item of this.Info_Download_List) {
      if (item.code == input.code) {
        return true
      }
    }
    return false
  }

  Info_Download_Remove(id: number) {
    this.Info_Download_List.splice(id, 1)
    this.Alertify_Service.SuccessMessage("Deleted successfully.")
    this.QRCodeInputDownload.nativeElement.focus();
  }


  QRCodeChangeDownload() {
    if(this.DowloadType=='1' && this.LetterSchedules=='0')
    {
      this.Alertify_Service.ErrorMessage("Select a mission.")
    }
    else{
      this.Procssing = true

      var Code: Array<string> = []
      for (let item of this.Info_Download_List) {
        Code.push(item.dsc)
      }

      this.DeviceBehfa_Service.PostDownload(Code, Number(this.DowloadType), Number(this.LetterSchedules), this.Token).subscribe(
        data => {

          this.Procssing = false
          this.QRCodeInputDownload_Esc()
          this.Info_Download_List = data

          this.FormSubmitted=true
          this.Alertify_Service.SuccessMessage("The equipment was checked for exit.")

          this.ReadData_Mission_Device()

        }, error => {
          localStorage.clear()
          location.reload();

        }
      )
    }

  }



  //#endregion

  //#region Mission

  DataList_Mission:Array<General_Interface>=[]
  ReadData_Mission(){
    this.LetterSchedules='0'
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetActiveMission(this.Token+'').subscribe(
      data=>{
        this.Procssing=false
        this.DataList_Mission=data
      }
    )
  }

  DataList_Mission_Device:Array<DeviceBehfa_Interface>=[]
  ReadData_Mission_Device(){
    this.DataList_Mission_Device=[]
    this.Procssing=true
    this.LetterRequestCustomer_Service.GetActiveMissionDeviceBehfa(this.Token+'',Number(this.LetterSchedules),0).subscribe(
      data=>{
        this.Procssing=false
        this.DataList_Mission_Device=data
      }
    )
  }

  OnChange_DowloadType(){
    this.LetterSchedules = '0'
    this.DataList_Mission_Device=[]
  }

  //#endregion

}

